import { HTMLAttributes } from 'react';

import clsx from 'clsx';

const Card = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={clsx(
      'rounded border border-solid border-accent-muted bg-background-canvas p-5 text-[14px]',
      className,
    )}
    {...props}
  />
);

const CardHeading = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={clsx('mb-2.5 text-[18px]', className)} {...props} />
);

const CardInstructions = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={clsx('my-5px text-[12px] text-gray-500', className)} {...props} />
);

export { Card, CardHeading, CardInstructions };
